import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { JsonEditorOptions } from 'ang-jsoneditor';

export interface JsonEditorDialogData {
  value: any;
  readOnly: boolean;
}

export interface JsonEditorDialogResult {
  saved: boolean;
  value: any;
}

@Component({
    selector: 'app-json-editor-dialog',
    templateUrl: './json-editor-dialog.component.html',
    styleUrls: ['./json-editor-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class JsonEditorDialogComponent {
  public value: any;
  public initialValue: any;
  public readOnly = false;

  constructor(
    private dialogRef: MatDialogRef<JsonEditorDialogComponent, JsonEditorDialogResult>,
    @Inject(MAT_DIALOG_DATA) private data: JsonEditorDialogData,
  ) {
    this.value = this.cloneValue(data?.value ?? {});
    this.initialValue = this.cloneValue(data?.value ?? {});
    this.readOnly = !!data?.readOnly;
  }

  handleChange(value: any): void {
    if (value instanceof Event) {
      return;
    }

    this.value = this.cloneValue(value);
  }

  close(): void {
    this.dialogRef.close({saved: false, value: this.cloneValue(this.initialValue)});
  }

  save(): void {
    this.dialogRef.close({saved: true, value: this.cloneValue(this.value)});
  }

  editorOptions(): JsonEditorOptions {
    const options = new JsonEditorOptions();
    if (this.readOnly) {
      options.mode = 'view';
      options.modes = ['view', 'tree'];
      options.onEditable = () => false;
    } else {
      options.modes = ['text', 'tree', 'view'];
    }
    return options;
  }

  private cloneValue<T>(value: T): T {
    if (value === undefined) {
      return value;
    }

    try {
      return structuredClone(value);
    } catch {
      return value === null ? value : JSON.parse(JSON.stringify(value));
    }
  }
}
